import { render, staticRenderFns } from "./smsSettings.vue?vue&type=template&id=7ed17370&scoped=true"
import script from "./smsSettings.vue?vue&type=script&lang=js"
export * from "./smsSettings.vue?vue&type=script&lang=js"
import style0 from "./smsSettings.vue?vue&type=style&index=0&id=7ed17370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed17370",
  null
  
)

export default component.exports